var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 3.33333H7.33333C7.7 3.33333 8 3.03333 8 2.66667C8 2.3 7.7 2 7.33333 2H3.33333C2.6 2 2 2.6 2 3.33333V12.6667C2 13.4 2.6 14 3.33333 14H7.33333C7.7 14 8 13.7 8 13.3333C8 12.9667 7.7 12.6667 7.33333 12.6667H3.33333V3.33333Z",
    fill: "#CB213C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7667 7.76666L11.9067 5.90666C11.8603 5.85903 11.8008 5.82632 11.7357 5.81271C11.6706 5.7991 11.603 5.80522 11.5414 5.83027C11.4799 5.85533 11.4272 5.89819 11.3901 5.95336C11.353 6.00854 11.3333 6.07352 11.3333 6.14V7.33333H6.66667C6.3 7.33333 6 7.63333 6 8C6 8.36666 6.3 8.66666 6.66667 8.66666H11.3333V9.86C11.3333 10.16 11.6933 10.3067 11.9 10.0933L13.76 8.23333C13.8933 8.10666 13.8933 7.89333 13.7667 7.76666Z",
    fill: "#CB213C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.dd78ed110960c394ca744ea69a631104.svg";
export { ForwardRef as ReactComponent };